// Create React App exposes only variables prefixed with REACT_APP_ via process.env.
// Set REACT_APP_API_URL in .env (e.g. http://localhost:8000). Restart `npm start` after changes.

export const config = {
  serverApi: process.env.REACT_APP_API_URL,
};
